import { Component, Input, ElementRef, ViewChildren, SimpleChanges } from '@angular/core';
import { FormControlName } from '@angular/forms';
import { ProjectItemWithSelectionComponent } from './project-item-withselection.component';
import { GenericValidator } from '../shared/generic-validator';
import { fromEvent, merge, Observable } from 'rxjs';
import { ILookup } from '../shared/lookup';
import { debounceTime } from 'rxjs/internal/operators/debounceTime';

@Component({
    selector: 'project-contact',
    standalone: false,
    templateUrl: 'project-contact.component.html',
    styleUrls: ['./project-contact.component.css']
})
export class ProjectContactComponent extends ProjectItemWithSelectionComponent {
    private validationMessages: { [key: string]: { [key: string]: string } };
    private genericValidator: GenericValidator;
    @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];
    displayMessage: { [key: string]: string } = {};
    @Input('tags')
    public tags: ILookup[];

    constructor() {
        super();
        this.validationMessages = {
            email: {
                pattern: 'Please Enter a valid Email.'
            },
            name: {
                maxlength: 'Contact Name Cannot be Longer than 80 Characters'
            }
        }
        this.genericValidator = new GenericValidator(this.validationMessages);
    }

    get showEmailNotification(): boolean {
        const title = this.projectItemForm.get('title').value;
        return title === 'Clearance Contact' || title === 'Head of Department';
    }

    ngAfterViewInit() {
        let controlBlurs: Observable<any>[] = this.formInputElements
            .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));

        merge(this.projectItemForm.valueChanges, ...controlBlurs)
        .pipe(
            debounceTime(500)
        )
        .subscribe(value => {
            this.displayMessage = this.genericValidator.processMessages(this.projectItemForm);
        });

        this.syncEmailNotificationDisabledState();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tags']) {
            this.tags = changes['tags'].currentValue;
        }
        if (changes['readOnly'] || changes['group']) {
            this.syncEmailNotificationDisabledState();
        }
    }

    /** Prefer FormControl.disable/enable over template [disabled] (TA-007 / TR-007). */
    private syncEmailNotificationDisabledState(): void {
        if (!this.projectItemForm) {
            return;
        }
        const ctrl = this.projectItemForm.get('emailNotification');
        if (!ctrl) {
            return;
        }
        if (this.readOnly) {
            ctrl.disable({ emitEvent: false });
        } else if (ctrl.disabled) {
            ctrl.enable({ emitEvent: false });
        }
    }
}
